import { AccountType, AccountTypes } from './globals/types';

interface GetBasicPropsResponse {
  isBasicPropConfiguration: boolean;
  userId: string | null;
  accountTypes: AccountType[];
}

export const getRootElement = (): HTMLElement | null => {
  return document.getElementById('root');
};

export const getBasicProps = (): GetBasicPropsResponse => {
  const ReactRootEl = document.getElementById('root');
  const userId = ReactRootEl?.getAttribute('data-user-id') || null;
  const accountTypeString =
    ReactRootEl?.getAttribute('data-account-type') || null;
  const accountTypeAttrArr = accountTypeString?.split(',') || [];
  const accountTypes = accountTypeString
    ? AccountTypes.filter((type) => accountTypeAttrArr.includes(type))
    : [];
  const isBasicPropConfiguration = !!userId && !!accountTypes.length;
  return {
    isBasicPropConfiguration,
    userId,
    accountTypes,
  };
};
